<script>
import PagenationContainer from "@/components/common/PagenationContainer.vue";
import visionCheckCharts from "@/components/patientManagement/visionCheckCharts.vue";
import moment from "moment";
import up1 from "@/assets/up1.png";
import up2 from "@/assets/up2.png";
import up3 from "@/assets/up3.png";
import down1 from "@/assets/down1.png";
import down2 from "@/assets/down2.png";
import down3 from "@/assets/down3.png";
import macarons from "@/common/theme.json";
const mapMedalName = {
  精细刺激训练: "jingxiciji",
  视觉技巧训练: "shijuejiqiao",
  同时视: "tongshishi",
  融合视: "rongheshi",
  立体视: "litishi",
  Gabor训练: "gabor",
  对比敏感度训练: "duibimingandu",
  信息提取训练: "xinxitiqu"
};
const supCalcCountAll = source => {
  let formCount = {
    jingxiciji: 0,
    shijuejiqiao: 0,
    gabor: 0,
    duibimingandu: 0,
    xinxitiqu: 0,
    rongheshi: 0,
    tongshishi: 0,
    litishi: 0
  };

  let result = [];
  if (source && source.length > 0) {
    for (let item in source) {
      formCount[mapMedalName[source[item].labelName]] =
        formCount[mapMedalName[source[item].labelName]] + source[item].count;
    }
  }
  for (let type in mapMedalName) {
    if (formCount[mapMedalName[type]] > 0) {
      result.push({
        name: type,
        value: formCount[mapMedalName[type]]
      });
    }
  }
  return result;
};
const formatTextResult = (content, key) => {
  let formatText = content;
  for (let item in key) {
    if (key[item] !== undefined) {
      formatText = formatText.replace(
        "${" + item + "}",
        `<span style="color: red">${key[item]}</span>`
      );
    }
  }
  return formatText.split("<br>").map(o => `<span>${o}</span>`);
};
export default {
  components: {
    PagenationContainer,
    visionCheckCharts
  },
  props: {
    trainingEnabled: Boolean
    // sourceData: Object
  },
  data() {
    const patientId = this.$route.params.patientId;
    const ROLE_GROUP_OPTOMETRIST =
      localStorage.getItem("roles").indexOf("ROLE_GROUP_OPTOMETRIST") > -1;
    return {
      aiAlert: undefined,
      aiContent1: undefined,
      aiContent2: undefined,
      aiContent3: undefined,
      visionCheckResult1: [],
      visionCheckResult2: [],
      patientId,
      aiResult: false,
      visionCheckResult: [],
      editTrainWeight: false,
      trainWeightList: [],
      refreshChart: false,
      courseTrainingGameCount: [],
      ROLE_GROUP_OPTOMETRIST,
      noDataModal: true
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      let patientId = this.patientId;
      let data = await this.$http.getXiaomuzhinengVisionCheck(patientId);
      if (data) {
        this.aiResult = true;
        this.aiAlert = data.generalComment;
        this.courseTrainingGameCount = data.courseTrainingGameCount;
        let content = data.recipeStatement.content.replace('，视光师共进行了 ${key4} 次随访', '');

        this.aiContent1 = formatTextResult(
          content,
          data.recipeStatement.key
        );
        this.aiContent2 = formatTextResult(
          data.actionSuggestion.content,
          data.actionSuggestion.key
        );
        this.aiContent3 = data.reviewStatistics;
        this.trainWeightList = data.weightResource.map(o => {
          if (!o.weight && o.weight != "0") {
            o.weight = 1;
          }
          const subValue = parseInt(o.aiWeight) - parseInt(o.weight);
          if (subValue > 0) {
            if (subValue > 30) {
              o.icon = up3;
            } else if (subValue > 15) {
              o.icon = up2;
            } else {
              o.icon = up1;
            }
          } else if (subValue < 0) {
            if (Math.abs(subValue) > 30) {
              o.icon = down3;
            } else if (Math.abs(subValue) > 15) {
              o.icon = down2;
            } else {
              o.icon = down1;
            }
          } else {
            o.icon = undefined;
          }
          return o;
        });
        if (data.visionFunction && data.visionFunction.length > 10) {
          
          this.visionCheckResult1 = data.visionFunction.slice(0, Math.floor(data.visionFunction.length / 2)).reverse()
          this.visionCheckResult2 = data.visionFunction.slice(Math.floor(data.visionFunction.length / 2)).reverse();
        }
        this.$echarts.registerTheme("myMacarons", macarons);

        function getRandomInt(min, max) {
          min = Math.ceil(min);
          max = Math.floor(max);
          return Math.floor(Math.random() * (max - min)) + min; //不含最大值，含最小值
        }

        this.refreshChart = false;
        this.$nextTick(() => {
          for (let item in data.courseTrainingGameCount) {
            const chartComponent = document.getElementById(
              `PrecentageChart${item}`
            );
            const tempsupCalcCountAll = supCalcCountAll(
              data.courseTrainingGameCount[item]
            );
            const lastOne = data.courseTrainingGameCount
              ? data.courseTrainingGameCount.length
              : 0;
            const title =
              lastOne == 1 + parseInt(item)
                ? `疗程${1 + parseInt(item)}（进行中）`
                : `疗程${1 + parseInt(item)}`;
            let myChart = this.$echarts.init(chartComponent, "myMacarons");
            myChart.setOption({
              tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b}: {c} ({d}%)"
              },
              title: {
                text: title,
                textStyle: {
                  color: "#000000",
                  fontSize: 14,
                  fontWeight: 400
                }
              },
              series: [
                {
                  name: "训练比例",
                  type: "pie",
                  center: ["50%", "50%"],
                  radius: [0, "50%"],
                  labelLine: {
                    length: 5,
                    length: 5
                  },
                  emphasis: {
                    itemStyle: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)"
                    }
                  },
                  color: [
                    "#86C4EB",
                    "#C1BAEE",
                    "#86D49F",
                    "#86CAD4",
                    "#86A8D4",
                    "#F59498",
                    "#80E9E3",
                    "#63C9AC"
                  ],
                  data: tempsupCalcCountAll
                }
              ]
            });
          }

          this.refreshChart = true;
        });
      }
      // console.log("patient", data);
    },
    showTrainWeight() {
      this.editTrainWeight = true;
    },
    hideEdit() {
      this.editTrainWeight = false;
    },
    async saveEdit() {
      const data = this.trainWeightList.map(o => {
        return {
          gameId: o.gameId,
          //   enabled: o.enabled,
          weight: o.aiweight
        };
      });
      const result = await this.$http.setPatientTrainWeight(
        this.patientId,
        data
      );
      if (result) {
        this.$message.success("操作成功！");
        const resetResult = await this.$http;
      }
      this.editTrainWeight = false;
    }
  }
};
</script>

<template>
  <div class="xiaomuzhineng">
    <div v-if="trainingEnabled && aiResult">
      <div class="TextGroup" v-if="aiAlert">
        <el-alert class="aiAlert" type="warning" show-icon :closable="false">
          <span slot="title" style="font-size: 16px">
            {{aiAlert}}
            <el-button type="primary" @click="showTrainWeight" size="small">权重配置</el-button>
          </span>
        </el-alert>
      </div>
      <div>
        <img src="@/assets/xiaomuzhineng.png" class="xiaomuzhinengImg" />
        <div class="paragraph">
          <div class="content1">
            <div
              class="contentText"
              :style="{'padding-left': '25px'}"
              v-for="(item, index) in aiContent1"
              :key="index + 'item'"
            >
              <!--{{index == 0 ? '1、': ' '}}-->
              <span v-html="item" />
            </div>
          </div>
          <!--<div class="content2">
            <div
              class="contentText"
              v-for="(item, index) in aiContent2"
              :style="{'padding-left': `${index == 0 ? 'unset' : '22px'}`}"
              :key="index + 'item'"
            >
              {{index == 0 ? '2、': ' '}}
              <span v-html="item" />
            </div>
          </div>
          <div class="content2">
            <div class="contentText">3、{{aiContent3}}</div>
          </div>-->
        </div>
      </div>
      <div v-if="visionCheckResult1.length || visionCheckResult2.length">
        <span class="chartTitle">
          视功能指标
          <span class="secondTitle">（根据训练情况判定）</span>
        </span>
      </div>
      <el-row class="chartRow" v-if="visionCheckResult1.length || visionCheckResult2.length">
        <el-col :span="12">
          <visionCheckCharts
            class="versionCheckChart"
            v-if="refreshChart && visionCheckResult1.length"
            :visionCheckResult="visionCheckResult1"
            visionCheck="test1"
          />
        </el-col>
        <el-col :span="12">
          <visionCheckCharts
            class="versionCheckChart"
            v-if="refreshChart || visionCheckResult2.length"
            :visionCheckResult="visionCheckResult2"
            visionCheck="test2"
          />
        </el-col>
      </el-row>
      <div v-if="courseTrainingGameCount.length">
        <span class="chartTitle">疗程训练比例</span>
      </div>
      <el-row :gutter="24" class="trainPercentageView">
        <el-col
          :span="8"
          v-for="(chart, index) in courseTrainingGameCount"
          :key="'liaocheng' + index"
          class="trainPercentageCol"
        >
          <div class="trainPrecentageChart" :id="`PrecentageChart${index}`" />
        </el-col>
      </el-row>

      <operationDialog
        title="小沐建议权重配置"
        :Visible="editTrainWeight"
        class="editDialog"
        width="650px"
        @close="hideEdit"
        :center="true"
        :btnText="ROLE_GROUP_OPTOMETRIST?'接受建议并重置本疗程剩余训练' : '当前仅厂商视光师可用'"
        @confirm="saveEdit"
        :disabled="ROLE_GROUP_OPTOMETRIST ? false : true"
      >
        <el-alert
          class="existUserDialogAlert"
          title="训练游戏的权重值为0～10"
          type="warning"
          show-icon
          :closable="false"
        ></el-alert>
        <el-row style="background: #FAFAFA">
          <el-col :span="5">类别</el-col>
          <el-col :span="9">游戏名称</el-col>
          <el-col :span="3">权重值</el-col>
          <el-col :span="5">目标权重</el-col>
          <el-col :span="2" style="text-align: center"></el-col>
        </el-row>
        <el-row class="gameWeightRow" v-for="gameItem in trainWeightList" :key="gameItem.gameId">
          <el-col :span="5">{{gameItem.labelName}}</el-col>
          <el-col :span="9">{{gameItem.gameName}}</el-col>
          <el-col :span="3">{{gameItem.weight}}</el-col>
          <el-col :span="5">
            <el-input-number
              style="width: 100px"
              size="small"
              :max="10"
              :min="0"
              :step="1"
              :step-strictly="true"
              :controls="false"
              v-model="gameItem.aiWeight"
              type="text"
            />
          </el-col>
          <el-col :span="2" style="text-align: left">
            <img :src="gameItem.icon" class="upDownIcon" />
          </el-col>
        </el-row>
      </operationDialog>
    </div>
    <div class="noDataView" v-else>
      <img src="@/assets/aiNoData.png" class="noDataImg" />
      <div class="noDataContent">
        <div class="noDataTitle">暂无数据</div>
        <span
          v-if="trainingEnabled"
          style="padding: 12px 30px 15px "
          class="noDataTextView"
        >每周一分析前一周的训练，敬请期待</span>
        <span v-else class="noDataTextView">该患者已停止训练，小沐也无能为力啦～～</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.xiaomuzhineng {
  .chartRow {
    margin: 0px !important;
  }

  .versionCheckChart {
    margin-top: -30px;
    // border: 1px;
    // width: 47%;
    min-width: 350px;
    display: inline-block;
  }

  .upDownIcon {
    height: 15px;
  }

  .TextGroup {
    display: flex;
    justify-content: space-between;
    margin: 10px 2% 0px;
    line-height: 35px;

    .aiAlert {
      .el-alert__icon {
        margin-top: -4px;
      }
    }
  }

  .xiaomuzhinengImg {
    width: 180px;
    height: 227px;
    margin: 10px 40px 20px 30px;
  }

  .paragraph {
    display: inline-block;
    vertical-align: top;
    margin-top: 10px;
    margin-right: 15px;
    width: calc(100% - 275px);

    .content1 {
      //   display: inline-block;
      margin: 15px 0;
      max-width: 750px;
    }

    .content2 {
      //   display: inline-block;
      margin: 15px 0;
      max-width: 750px;
    }

    .contentText {
      line-height: 22px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
    }
  }

  .editDialog {
    .el-dialog__body {
      padding-left: 5px;
      padding-bottom: 10px;
      padding-top: 10px;
      max-height: 350px;
      overflow-y: auto;
      // border-top: 1px solid #EFEFEF;
      border-bottom: 1px solid #efefef;
    }

    .existUserDialogAlert {
      margin: 15px;
      width: auto;
      // padding-left: 10px;
      height: 36px;
      background: rgba(255, 251, 230, 1);
      border-radius: 4px;
      border: 1px solid rgba(255, 229, 143, 1);

      .el-alert__title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 22px;
      }
    }

    .el-row {
      line-height: 33px;
      margin: 5px 15px;
    }

    .operationDialog .el-dialog__footer {
      margin-top: 15px;

      .el-button--primary {
        width: 300px;
      }
    }
  }

  .noDataView {
    width: 100%;
    text-align: center;
    display: flex;

    .noDataImg {
      width: 155px;
      height: 155px;
      margin: 100px 0 0 25%;
      display: inline-block;
    }

    .noDataContent {
      // width: 155px;
      height: 155px;
      margin: 100px 0 0 0;
      display: inline-block;

      .noDataTitle {
        color: #7e7e7e;
        line-height: 22px;
        font-size: 16px;
        margin-top: 40px;
        margin-bottom: 10px;
        margin-left: 15px;
        text-align: left;
      }

      .noDataTextView {
        display: inline-block;
        background-image: url("~@/assets/nodataViewBg.png");
        background-size: cover;
        background-repeat: no-repeat;
        padding: 15px 30px;
        color: #ffffff;
        font-size: 14px;
      }
    }
  }

  .chartTitle {
    display: inline-block;
    font-size: 16px;
    font-weight: 500;
    margin-left: 40px;
    margin-bottom: -30px;

    .secondTitle {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
    }
  }

  .trainPercentageView {
    // display: flex;
    flex-wrap: wrap;
    margin: 40px 10px 0 !important;

    .trainPercentageCol {
      min-width: 350px;
      text-align: center;
    }

    .trainPrecentageChart {
      width: 330px;
      height: 300px;
      margin: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/patientManagement/xiaomuzhineng.vue